export function timeAgo(date: string | null | undefined): string {
    if (!date) return 'Never';
    const seconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
    const intervals = [
        { label: 'year', seconds: 31536000 }, { label: 'month', seconds: 2592000 },
        { label: 'day', seconds: 86400 }, { label: 'hour', seconds: 3600 },
        { label: 'min', seconds: 60 }
    ];
    for (const interval of intervals) {
        const count = Math.floor(seconds / interval.seconds);
        if (count >= 1) return `${count} ${interval.label}${count > 1 ? 's' : ''} ago`;
    }
    return 'Just now';
}
